export const LOCKE_PRODUCTION_ID = '1p48kcl0ftem2iee52ih34034';
export const LOCKE_STAGING_ID = '4pe9tnm1ob1g9e94a08itldueg';

export type User = {
  rcauid: string | undefined;
  countryCode: string | undefined;
  isSignedIn: boolean;
};

export type LockeClientId =
  | typeof LOCKE_PRODUCTION_ID
  | typeof LOCKE_STAGING_ID;

export type LockeConfig = {
  lockeClientId: LockeClientId;
  lockeSettingsUrl: string;
  lockeApiUrl: string;
  redirectUrl: string;
  rcaApiHost: string;
};

export type UserCookie = {
  myRcaId: string;
  lockeId: string;
  expiry: number;
};
